import { useSelector } from "react-redux";
import { StoreData } from "..";

export const useFeatureFlag = (featureName: string): boolean | undefined => {
  const featureEnabled = useSelector(
    (state: StoreData) => state.features[featureName],
  );
  return featureEnabled;
};
